/* eslint-disable @typescript-eslint/no-explicit-any */
import request from 'utils/request';

const marriageGoodsService = {
  getList: (params: any) => request.get(`/defective-product`, { params }),
  create: (data: any) => request.post('/defective-product', data),
  createWriteOff: (data: any) =>
    request.post('/defective-product/write-off', data),
  createReturn: (data: any) => request.post('/defective-product/return', data),
  delete: (pid: any) => request.delete(`/defective-product/${pid}`),
  update: (pid: any, data: any) =>
    request.put(`/defective-product/${pid}`, data)
};

export default marriageGoodsService;
